import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { cn } from '@/lib/utils';
const navigationItems = [
    { name: 'ABOUT US', href: '/about' },
    { name: 'SERVICE', href: '/services' },
    { name: 'WORKS', href: '/works' },
    { name: 'RECRUIT', href: '/recruit' },
    { name: 'CONTACT', href: '/contact' },
];
export default function MainNavigation() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const [scrollPosition, setScrollPosition] = useState(0);
    const location = useLocation();
    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 50);
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    useEffect(() => {
        if (isMenuOpen) {
            setScrollPosition(window.scrollY);
            document.body.style.overflow = 'hidden';
            document.body.style.position = 'fixed';
            document.body.style.width = '100%';
            document.body.style.top = `-${scrollPosition}px`;
        }
        else {
            document.body.style.overflow = '';
            document.body.style.position = '';
            document.body.style.width = '';
            document.body.style.top = '';
            window.scrollTo(0, scrollPosition);
        }
        return () => {
            document.body.style.overflow = '';
            document.body.style.position = '';
            document.body.style.width = '';
            document.body.style.top = '';
        };
    }, [isMenuOpen, scrollPosition]);
    return (<header className={cn('fixed top-0 left-0 w-full z-[100] transition-all duration-300', scrolled
            ? 'bg-white/90 backdrop-blur-md shadow-sm py-4'
            : 'py-6 bg-transparent', isMenuOpen && 'bg-white')}>
      <div className='container mx-auto px-6 md:px-12 flex justify-between items-center'>
        <Link to='/' className='text-navy font-bebas text-3xl tracking-wider transition-opacity hover:opacity-80'>
          MORIDEN SETSUBI
        </Link>

        {/* Desktop Navigation */}
        <nav className='hidden lg:flex items-center space-x-8'>
          {navigationItems.map((item) => (<Link key={item.name} to={item.href} className={cn('text-navy font-medium tracking-wide text-sm transition-all hover:text-skyblue', location.pathname === item.href && 'text-skyblue')}>
              {item.name}
            </Link>))}
        </nav>

        {/* Mobile Menu Button */}
        <button onClick={() => setIsMenuOpen(!isMenuOpen)} className='lg:hidden text-navy p-2 hover:bg-navy/5 rounded-full transition-colors' aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}>
          {isMenuOpen ? <X size={24}/> : <Menu size={24}/>}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (<div className='fixed inset-0 bg-white z-[90] lg:hidden overflow-y-auto'>
          {/* Close Button */}
          <button onClick={() => setIsMenuOpen(false)} className='absolute top-6 right-6 p-2 text-navy hover:bg-navy/5 rounded-full transition-colors' aria-label='Close menu'>
            <X size={24}/>
          </button>

          <nav className='flex flex-col space-y-6 items-center pt-24 pb-6 px-6'>
            {navigationItems.map((item) => (<Link key={item.name} to={item.href} onClick={() => setIsMenuOpen(false)} className='text-navy font-bebas text-3xl tracking-wide transition-colors hover:text-skyblue'>
                {item.name}
              </Link>))}
          </nav>

          <div className='mt-auto pt-12 text-center text-navy'>
            <p className='text-sm'>盛電設備工業株式会社</p>
            <p className='text-xs mt-2'>
              〒020-0839 岩手県盛岡市津志田南3-13-15
            </p>
            <p className='text-xs mt-1'>TEL: 019-681-3977</p>
          </div>
        </div>)}
    </header>);
}
